import { Plus, X } from "lucide-react";
import { Button } from "../../../_components/ui";
import "./_contacts-table.scss";

// Extracted from FinalizeDetails' live `sendProposalTo` contact table
// (CustomerDetails had a structurally-identical one, but it was dead,
// commented-out code of uncertain freshness - this one's built off the
// table that's actually rendered today).
function initials(name) {
  const parts = (name || "").trim().split(" ").filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

/**
 * A picked-contacts list with per-row remove + an "Add contacts" trigger.
 * Purely presentational - opening whatever contact-picker modal supplies
 * new contacts stays the caller's job. Also reused inside
 * `_components/contacts/ContactsPickerModal` itself, for that picker's own
 * "currently selected" section.
 *
 * Always renders as one framed table-like block (header row + bordered
 * body, matching TaxEditor's own header+box shape) instead of a bare "+ Add
 * contacts" button floating with no container - true whether populated or
 * empty, so the empty state doesn't visually disappear against whatever
 * section it's embedded in (previously: no border/box at all until at
 * least one contact existed). `title` is optional since some hosts
 * (FinalizeDetailsStep, ContactsPickerModal's own "selected" section)
 * already render their own external heading above this.
 */
const ContactsTable = ({
  contacts = [],
  onAdd,
  onRemove,
  addLabel = "Add contacts",
  addDisabled = false,
  addDisabledTitle,
  disabled = false,
  title,
}) => (
  <div className="contacts-table">
    <div className="contacts-table__header">
      {title && <h4 className="contacts-table__title">{title}</h4>}
      <Button
        variant="ghost"
        size="sm"
        icon={<Plus size={14} />}
        onClick={onAdd}
        disabled={disabled || addDisabled}
        title={addDisabled ? addDisabledTitle : undefined}
      >
        {addLabel}
      </Button>
    </div>

    {contacts.length === 0 ? (
      <p className="contacts-table__empty">No contacts added yet.</p>
    ) : (
      <ul className="contacts-table__list">
        {contacts.map((contact) => {
          const name = contact.contactName || contact.name || "";
          const email = contact.mail || contact.email || "";
          return (
            <li key={contact._id} className="contacts-table__row">
              <span className="contacts-table__avatar" aria-hidden="true">
                {initials(name)}
              </span>
              <div className="contacts-table__details">
                <span className="contacts-table__name">{name}</span>
                <span className="contacts-table__email">{email}</span>
              </div>
              <Button
                variant="ghost-danger"
                size="sm"
                iconOnly
                icon={<X size={14} />}
                onClick={() => onRemove(contact._id)}
                aria-label={`Remove ${name || "contact"}`}
                disabled={disabled}
              />
            </li>
          );
        })}
      </ul>
    )}
  </div>
);

export default ContactsTable;
